import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import "./CustomCenterModel.scss";
import PropTypes from "prop-types";

const CustomCenterModel = ({ children, modalTitleIcon, zIndex = 99, useCustomBg, ...props }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      const timer = setTimeout(() => {
        setIsTransitioning(true);
      }, 200);
      return () => clearTimeout(timer);
    } else {

      setIsTransitioning(false);
    }
  }, [props.isOpen]);

  if (!props.isOpen && !isTransitioning) return null;

  return ReactDOM.createPortal(
    <div className={`center-model ${isTransitioning ? "active-model" : ""} ${useCustomBg ? 'custom-bg-color' : ''}`}>
      <div className={`center-model-section ${props.className}`} style={{ zIndex }}>
        <div className={`model-content ${props.contentClass ? props.contentClass : 'content-45'} ${props.isOpen ? "transform-in" : "transform-out"}`}>
          <div className="model-header">
            <span className="modal-icon">
              <Image imagePath={modalTitleIcon} altText="Title Icon" />
            </span>
            <div className="model-title">{props.modalTitle}</div>
            <button
              style={{ border: "unset", background: 'none' }}
              className="close-btn"
              onClick={props.onClose ? props.onClose : null}
            >
              <Image
                imgCustomClassName="default"
                imagePath={AppIcons.CloseIcon}
                altText="Close"
              />
            </button>
          </div>
          <div className="model-body">
            <div className="body-center">{children}</div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

CustomCenterModel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  modalTitleIcon: PropTypes.string.isRequired,
  zIndex: PropTypes.number,
  useCustomBg: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string,
  onClose: PropTypes.func,
  contentClass: PropTypes.string,
};

export default CustomCenterModel;
